package org.moxultimate.topwithmox.product.ui

import androidx.compose.runtime.Immutable
import org.moxultimate.topwithmox.product.data.ProductContentResponse

/**
 * ProductState
 * Screen states for the Products page driven by [ProductViewModel].
 */
@Immutable
sealed class ProductState {
    data object Loading : ProductState()
    data class Error(val error: String, val statusCode: Int = 0) : ProductState()
    data class Success(
        val contentList: List<ProductContentResponse>,
        val hasMore: Boolean = true,
    ) : ProductState()
}
